/** Description: Loading statuses of the store middlewares. */
export enum EntityStatus {
    IDLE = 'idle',
    PENDING = 'pending',
    SUCCEEDED = 'succeeded',
    FAILED = 'failed'
}